/* ═══════════════════════════════════════════════════════════════════════════════════
   Boni delivery-plan maths.  window.BoniPlan

   ⚠ HAND-WRITTEN ASSET. This is NOT generated by scripts/build-web.sh — there is no
   JSX source for it, do not go looking for one. It is loaded from theme.liquid's <head>
   (before boni-app.js) precisely so that BOTH the server-rendered PDP's inline script
   AND the React bundle can call it. Section markup renders before the scripts at the
   end of <body>, so anything the PDP needs must already exist in head.

   Ported from wizard/subscriptions.yaml's `finish_have` OnLoad, which computed the same
   thing in Jinja. Kept as WEIGHT BANDS rather than 70 * kg^0.75 because the power
   operator was never verified on the Armory build the wizard runs on, and a lookup
   table cannot silently mis-evaluate. Keep the two in step if either changes.

   Pure functions only — no DOM, no storage, no side effects. The PDP wires it up.
   ═══════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Maintenance grams/day for an average adult dog at each weight band.
  var BANDS = [
    [3, 60], [6, 120], [11, 195], [16, 265], [21, 325],
    [26, 380], [31, 440], [41, 545]
  ];
  var BAND_TOP = 650; // 41 kg and up

  // Freshness-after-opening vs price-per-kg. A business call, deliberately tunable:
  // above this many days we drop to the smaller bag rather than have food sit open.
  var MAX_BAG_DAYS = 70;

  function gramsPerDay(kg, stage, activity, neutered) {
    kg = parseFloat(kg);
    if (!kg || kg <= 0) return null;

    var base = BAND_TOP;
    for (var i = 0; i < BANDS.length; i++) {
      if (kg < BANDS[i][0]) { base = BANDS[i][1]; break; }
    }

    var st = stage === 'puppy' ? 1.4 : (stage === 'senior' ? 0.8 : 1.0);
    var ac = activity === 'low' ? 0.9 : (activity === 'high' ? 1.2 : 1.0);
    var nu = neutered === true ? 0.9 : 1.0;

    return Math.round(base * st * ac * nu);
  }

  function daysFor(bagKg, gpd) {
    if (!gpd || !bagKg) return null;
    return Math.round((parseFloat(bagKg) * 1000) / gpd);
  }

  /* Pick a bag. Prefer the biggest one the owner can get through in MAX_BAG_DAYS;
     if every bag would outlast that, take the smallest. bags = [{id, kg}] */
  function bagFor(bags, gpd) {
    if (!bags || !bags.length || !gpd) return null;
    var sorted = bags.slice().sort(function (a, b) { return parseFloat(a.kg) - parseFloat(b.kg); });
    var pick = null;
    for (var i = 0; i < sorted.length; i++) {
      var d = daysFor(sorted[i].kg, gpd);
      if (d !== null && d <= MAX_BAG_DAYS) pick = sorted[i]; // keep climbing while it still fits
    }
    if (!pick) pick = sorted[0];
    return { id: pick.id, kg: pick.kg, days: daysFor(pick.kg, gpd) };
  }

  /* Pick a cadence: the interval closest to how long the bag lasts, and on a tie the
     SHORTER one, because running out is the villain the whole product is about.

     NOTE: the wizard used a hardcoded threshold table (<11, <23, <38, <54) written for
     exactly these five cadences. This is the general form. It agrees with that table
     everywhere except two narrow bands (36-37 and 51-53 days), where this picks the
     next interval up. Difference is a few days on a plan Boni adjusts in chat anyway.
     plans = [{id, days}] */
  function cadenceFor(plans, bagDays) {
    if (!plans || !plans.length || !bagDays) return null;
    var best = null, bestGap = Infinity;
    plans.forEach(function (p) {
      var gap = Math.abs(p.days - bagDays);
      if (gap < bestGap || (gap === bestGap && best && p.days < best.days)) {
        best = p; bestGap = gap;
      }
    });
    return best;
  }

  /* One call that does the whole job. Returns null if there is nothing to say. */
  function build(opts) {
    var gpd = gramsPerDay(opts.kg, opts.stage, opts.activity, opts.neutered);
    if (!gpd) return null;
    var bag = bagFor(opts.bags, gpd);
    if (!bag) return null;
    var cad = cadenceFor(opts.plans, bag.days);
    return { gramsPerDay: gpd, bag: bag, cadence: cad };
  }

  window.BoniPlan = {
    gramsPerDay: gramsPerDay,
    daysFor: daysFor,
    bagFor: bagFor,
    cadenceFor: cadenceFor,
    build: build,
    MAX_BAG_DAYS: MAX_BAG_DAYS
  };
})();
